/* eslint-disable no-console */
<template>
  <div class="createCustomer">
    <page-header @back="routeToHomePage" :content="content" title="Dashboard" />
      <Form :model="form" :rules="rules" ref="form" label-width="250px">
        <FormItem label="Email"
          prop="email"
          :rules="[
          { required: true, message: 'Please input email address', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address',
            trigger: ['blur', 'change'] }
          ]"
        >
          <Input :disabled="disableInput" v-model="form.email" required clearable size="small"/>
        </FormItem>
        <!-- <FormItem label="Username"
         prop="userName"
          :rules="[
          { required: true, message: 'Please input user name', trigger: 'blur' },
          { type: 'string', message: 'Please input correct username',
            trigger: ['blur', 'change'] }
          ]"
        >
          <Input :disabled="disableInput" v-model="form.userName" size="small" clearable />
        </FormItem> -->
        <FormItem label="Company Name"
          prop="company"
          :rules="[
          { required: true, message: 'Please input company name', trigger: 'blur' },
          { type: 'string', message: 'Please input correct company name',
            trigger: ['blur', 'change'] }
          ]"
        >
          <Input
              placeholder="Company Name"
              v-model="form.company"
              size="small"
              clearable
            />
        </FormItem>
        <el-form-item label="Entity Type" prop="entity">
          <el-select v-model="form.entity" :style="{width: '100%'}" size="small">
            <el-option
              v-for="entity in entityOptions"
              :key="entity.value"
              :label="entity.label"
              :value="entity.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <FormItem label="Organization State"
          prop="orgState"
          :rules="[
          { type: 'string', message: 'Please input correct state',
            trigger: ['blur', 'change'] }
          ]"
        >
          <State :country="form.country" :given-state="form.orgState" @change="onOrgStateChange"/>
        </FormItem>
        <FormItem label="Full Name"
          prop="primaryContact.name"
          :rules="[
          { type: 'string', message: 'Please input correct full name',
            trigger: ['blur', 'change'] }
          ]"
        >
          <Input
            v-model="form.primaryContact.name" placeholder="Primary contact name" size="small" clearable />
        </FormItem>
        <FormItem label="Title"
          prop="primaryContact.title"
        >
          <Input
            v-model="form.primaryContact.title" placeholder="Primary contact title" size="small" clearable />
        </FormItem>
        <FormItem label="Salesforce Customer ID"
          prop="salesforceId"
        >
          <Input
            v-model="form.salesforceId" placeholder="Customer ID" size="small" clearable />
        </FormItem>
        <FormItem
          :rules="[
          { type: 'string', message: 'Please select country',
            trigger: ['blur', 'change'] }
          ]"
          label="Country"
          prop="country"
        >
          <el-select
            v-model="form.country"
            placeholder="Select Country"
            size="small"
            style="width: 100%;"
            @change="() => resetStateAndZip()"
          >
            <el-option
              v-for="country in countries"
              :key="country.value"
              :label="country.label"
              :value="country.value"
            ></el-option>
          </el-select>
        </FormItem>
        <FormItem
        label="Address Line 1"
        prop="address"
          :rules="[
          { type: 'string', message: 'Please input correct address',
            trigger: ['blur', 'change'] }
          ]"
        >
          <Input v-model="form.address" size="small" clearable />
        </FormItem>
        <FormItem
        label="Address Line 2"
        prop="addres2"
          :rules="[
          { type: 'string', message: 'Please input correct address',
            trigger: ['blur', 'change'] }
          ]"
        >
          <Input v-model="form.address2" size="small" clearable />
        </FormItem>
        <FormItem
        label="City"
        prop="city"
          :rules="[
          { type: 'string', message: 'Please input correct city',
            trigger: ['blur', 'change'] }
          ]"
        >
          <Input v-model="form.city" size="small" clearable />
        </FormItem>
        <FormItem label="State"
          prop="state"
          :rules="[
          { type: 'string', message: 'Please input correct state',
            trigger: ['blur', 'change'] }
          ]"
        >
          <State :country="form.country" :given-state="form.state" @change="onStateChange"/>
        </FormItem>
        <FormItem label="Zip Code"
          prop="zip"
        >
          <el-input v-model="form.zip" size="small" clearable>
          </el-input>
        </FormItem>
        <FormItem
          label="Phone"
          prop="phone"
          :rules="[
          { required: true, message: 'Please input phone', trigger: 'blur' },
          { type: 'string', message: 'Please input correct phone',
            trigger: ['blur', 'change'] }
          ]"
        >
          <Input type="tel" v-model="form.phone" size="small" clearable />
        </FormItem>
        <FormItem label="Industry/Business">
            <el-select v-model="form.business" size="small" style="width: 100%;">
              <el-option :key="option" v-for="option of businessOptions" :value="option">
              </el-option>
            </el-select>
          </FormItem>
          <FormItem label="Sub-industry">
            <el-select v-model="form.subIndustry" style="width: 100%;">
              <el-option :key="option" v-for="option of subIndustryOptions" :value="option">
              </el-option>
            </el-select>
          </FormItem>
          <FormItem label="Tax Exempted" prop="taxExempted">
            <el-switch
              v-model="form.taxExempted"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="True"
              inactive-text="False"
            ></el-switch>
          </FormItem>
          <FormItem label="Tax"
            prop="taxId"
          >
            <Input
                placeholder="Tax ID"
                :disabled="disableInput"
                v-model="form.taxId"
                size="small"
                clearable
              />
          </FormItem>
          <FormItem>
            <Button type="primary" @click="createCustomer">
              {{buttonText}}
          </Button>
          <Button @click="routeToHomePage">
            Cancel
          </Button>
        </FormItem>
      </Form>
  </div>
</template>

<script>
import axios from 'axios';
import { Input, Form, FormItem, Button, Radio, Checkbox, CheckboxGroup, Alert, PageHeader } from 'element-ui';
import { countries } from '../utils/countries';
import State from './Sate.vue';
import { CUSTOMER_API_BASE, PG_API_BASE, AUTH_API_BASE } from '../env';

export default {
  name: 'CreateCustomer',
  props: {
    customerId: { type: String, default: null },
    facility: { type: String, default: null },
  },
  components: { Input, Form, FormItem, Button, Radio, Checkbox, CheckboxGroup, Alert, PageHeader, State },
  computed: {
    content() {
      if (this.customerId) return 'Edit Customer';
      return 'Create Customer';
    },
    disableInput() {
      if (this.customerId) return true;
      return false;
    },
    buttonText() {
      if (this.customerId) return 'Save';
      return 'Create';
    },
  },
  data() {
    const checkZipCode = (_rule, value, callback) => {
      const caRegExp = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
      const usRegExp = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
      if (!value) {
        callback();
        return;
      }

      // US, PR, and MX have the same postcode validation
      if (['us', 'pr', 'mx'].includes(this.form.country)) {
        if (usRegExp.test(value)) {
          callback();
        }
      } else if (this.form.country === 'ca') {
        if (caRegExp.test(value)) {
          callback();
        }
      } else if (this.form.country === 'bh') {
        if (value === '00000') {
          callback();
        }
      }
      callback(new Error('Invalid Zip Code'));
    };

    const checkTaxId = (_rule, value, callback) => {
      if (!value) {
        callback();
      }

      const regexp = /(^\d{9}$)|(^\d{3}-\d{2}-\d{4}$)|(^\d{3} \d{3} \d{3}$)|(^\d{2}-\d{7}$)|(^\d{2} \d{7}$)/;
      if (this.form.country !== 'us') {
        callback();
      }

      if (regexp.test(value)) { callback(); }

      callback(new Error('Invalid TaxID'));
    };
    return {
      countries,
      error: '',
      entityOptions: [
        { label: 'Corporation', value: 'Corporation' },
        { label: 'Limited Liability Company', value: 'Limited Liability Company' },
        { label: 'Limited Liability Partnership', value: 'Limited Liability Partnership' },
        { label: 'Limited Partnership', value: 'Limited Partnership' },
        { label: 'Other', value: 'Other' },
        { label: 'Sole Proprietorship (Canada)', value: 'Sole Proprietorship (Canada)' },
        { label: 'Partnership (Canada)', value: 'Partnership (Canada)' },
        { label: 'Corporation (Canada)', value: 'Corporation (Canada)' },
        { label: 'Other (Canada)', value: 'Other (Canada)' }
      ],
      form: {
        company: null,
        email: null,
        entity: '',
        // userName: null,
        fullName: null,
        address: null,
        address2: null,
        taxExempted: false,
        country: 'us',
        orgState: '',
        city: null,
        state: null,
        zip: null,
        phone: null,
        taxId: null,
        business: null,
        subIndustry: null,
        salesforceId: null,
        primaryContact: {
          name: '',
          title: '',
        },
        personalInformation: {
          state: '',
          referral: 'Online',
        },
        alternateContactInformation: {
          contact: '',
          phone: '',
        },
        additionalInformation: {
          federalEIN: '',
        },
      },
      rules: {
        zip: [
          { validator: checkZipCode, trigger: ['blur', 'change'] },
        ],
        taxId: [
          { validator: checkTaxId, trigger: 'blur' },
          {
            type: 'string',
            message: 'Please input correct Tax ID',
            trigger: ['blur', 'change'],
          },
        ],
      },
      businessOptions: [
        'Auto Repair / Maintenance',
        'Computers / Electronics',
        'Construction / Remodeling',
        'Construction Materials / Supplies',
        'Consumer Services',
        'eCommerce / Online Retail',
        'Grocery / Food Wholesale',
        'Home Staging',
        'Logistics',
        'Manufacturing',
        'Media / Entertainment',
        'Moving Company / Services',
        'Non-Profit',
        'Personal Storage',
        'Real Estate Agents / Appraiser',
        'Sports / Recreation',
        'Textiles / Apparel',
        'Warehousing / Commercial Storage',
        'Wholesale / Distribution'
      ],
      subIndustryOptions: [
        'Long Term / Dead storage',
        'Equipment / supplies storage',
        'eCommerce / Order fulfillment',
        '3PL / Transload',
        'General warehousing',
        'R&D / Prototyping / Testing',
        'Manufacturing',
        'Wholesale & Distribution',
        'Assembly',
        'Athletic Training',
        'Showroom / Retail',
        'Other'
      ],
    };
  },
  methods: {
    onStateChange(state) {
      this.form.state = state;
    },
    onOrgStateChange(state) {
      this.form.orgState = state;
    },
    resetStateAndZip() {
      this.form.orgState = null;
      this.form.state = null;
      this.form.zip = null;
      if (this.form.country === 'bh') {
        this.form.zip = '00000';
      } else if (this.form.country === 'pr') {
        this.form.state = 'pr';
      }
    },
    async createCustomer() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            if (!this.customerId) {
              try {
                await axios.post(`${CUSTOMER_API_BASE}/customers/v1`, {
                  ...this.form,
                  ...(this.$root.state.facility ? { locations: [this.$root.state.facility] } : {}),
                }, {
                  headers: {
                    Authorization: `Bearer ${this.$keycloak.token}`,
                  },
                });

                this.$message.success({
                  title: 'Success',
                  message: 'New Customer added successfully.',
                });
              } catch (err) {
                this.$message.error({
                  title: 'error',
                  message: err.response.data,
                });
                this.error = err.response.data;
                return;
              }
            } else {
              try {
                const {
                  company,
                  fullName,
                  address,
                  address2,
                  country,
                  city,
                  state,
                  zip,
                  phone,
                  taxId,
                  business,
                  subIndustry,
                  primaryContact,
                  salesforceId,
                  entity,
                  orgState,
                  taxExempted,
                } = this.form;
                await axios.put(`${CUSTOMER_API_BASE}/customers/v1/${this.customerId}`, {
                  company,
                  fullName,
                  address,
                  address2,
                  country,
                  city,
                  state,
                  zip,
                  phone,
                  taxId,
                  business,
                  subIndustry,
                  primaryContact,
                  salesforceId,
                  entity,
                  orgState,
                  taxExempted,
                }, {
                  headers: {
                    Authorization: `Bearer ${this.$keycloak.token}`,
                  },
                });
                const [firstName, middlename, lastName] = primaryContact && primaryContact.name ? primaryContact.name.split(' ') : '';
                const { data } = await axios.get(`${AUTH_API_BASE}/customers`, {
                  params: {
                    email: this.form.email,
                  },
                  headers: {
                    Authorization: `Bearer ${this.$keycloak.token}`,
                  },
                });

                const keycloakAccount = data[0];

                if (firstName && lastName && keycloakAccount) {
                  await axios.put(`${AUTH_API_BASE}/customer/${keycloakAccount.id}`, {
                    firstName,
                    lastName: lastName ? `${middlename} ${lastName}` : middlename,
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${this.$keycloak.token}`,
                    },
                  });
                  await axios.put(
                    `${PG_API_BASE}/customer/${this.customerId}`,
                    {
                      ...(firstName ? { firstName } : {}),
                      ...(lastName ? { lastName } : {}),
                      phone,
                      company,
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${this.$keycloak.token}`,
                      },
                    },
                  );
                }

                this.$message.success({
                  title: 'Success',
                  message: 'Customer updated successfully.',
                });
              } catch (err) {
                this.error = err.message ? err.message : err.response.data;
                this.$message.error({
                  title: 'error',
                  message: this.error,
                });
                return;
              }
            }
          } else {
            return;
          }
          if (this.customerId) {
            this.$router.push({ name: this.$root.state.facility ? 'Facility Customer' : 'Customer', params: { id: this.customerId, ...(this.$root.state.facility ? { facility: this.$root.state.facility } : {}) } });
            return;
          }
          this.$router.push(this.$root.state.facility ? { name: 'Facility Dashboard', params: { facility: this.$root.state.facility } } : { name: 'Dashboard' });
        });
      } catch (err) {
        console.log(err);
      }
    },
    routeToHomePage() {
      if (this.facility) {
        this.$router.push({
          name: 'Facility Customer',
          params: { id: this.customerId, facility: this.facility },
        });
        return;
      }

      this.$router.push({
        name: 'Customer',
        params: { id: this.customerId },
      });
    },
  },
  async mounted() {
    try {
      if (this.customerId) {
        const customer = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/${this.customerId}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        if (!customer.data.primaryContact) {
          customer.data.primaryContact = { name: '' };
        }
        this.form = customer.data;
      }
    } catch (err) {
      console.log(err);
    }
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CreateCustomer.vue